var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBell = function SvgIconBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-hidden": "true",
    viewBox: "0 0 16 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.964 0C6.88 0 6.037.892 6.037 2v.337C3.629 3.17 1.943 5.386 1.943 8v3.602l-1.565 2.23c-.482.602-.482 1.409-.12 2.084.36.662.963 1.084 1.685 1.084h3.01c0 1.663 1.445 3 3.01 3a2.987 2.987 0 0 0 3.01-3h3.01c.723 0 1.446-.422 1.807-1.084.361-.675.24-1.482-.24-2.085l-1.566-2.229V8c0-2.614-1.686-4.831-3.974-5.663V2c0-1.108-.963-2-2.046-2m1.083 15H1.943l1.565-2 .12-.217c.242-.35.362-.759.362-1.18V8c0-2.205 1.806-4 3.974-4 2.287 0 3.973 1.795 3.973 4v3.602c0 .422.24.832.482 1.181l.12.217 1.445 2H9.047m-1.083 3C7.482 18 7 17.554 7 17h2.047c0 .554-.481 1-1.083 1"
  })));
};
export default SvgIconBell;